import React from "react";

export type TwitterLogoProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 15,
    height: 15,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 60,
    height: 60,
  },
};

export const TwitterLogo = React.forwardRef<SVGSVGElement, TwitterLogoProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "black" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];

    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 30 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 3.75024C28.875 4.25024 27.75 4.62524 26.5 4.75024C27.75 4.00024 28.75 2.75024 29.25 1.37524C28 2.12524 26.75 2.62524 25.375 2.87524C24.25 1.62524 22.625 0.875244 20.875 0.875244C17.5 0.875244 14.75 3.62524 14.75 7.00024C14.75 7.50024 14.75 8.00024 14.875 8.37524C9.625 8.12524 5.125 5.62524 2.125 1.87524C1.5 2.87524 1.25 3.87524 1.25 5.00024C1.25 7.12524 2.375 9.00024 4 10.1252C3 10.1252 2 9.87524 1.25 9.37524C1.25 9.37524 1.25 9.37524 1.25 9.50024C1.25 12.5002 3.375 15.0002 6.125 15.5002C5.625 15.6252 5.125 15.7502 4.5 15.7502C4.125 15.7502 3.75 15.7502 3.375 15.6252C4.125 18.1252 6.375 19.8752 9.125 19.8752C7 21.5002 4.375 22.5002 1.5 22.5002C1 22.5002 0.5 22.5002 0 22.3752C2.75 24.1252 6 25.1252 9.375 25.1252C20.75 25.1252 26.875 15.7502 26.875 7.62524C26.875 7.37524 26.875 7.12524 26.875 6.87524C28.125 6.00024 29.125 4.87524 30 3.75024Z"
          fill={color}
        />
      </svg>
    );
  }
);

TwitterLogo.displayName = "TwitterLogo";
